<template>
  <div id="home">
    <!-- 视频列表 -->
    <div class="content">
      <div class="lists">
        <div class="list" v-for="(v, index) in activityList"
          :key="index">
          <a v-if="isExternalLink(v)" :href="v.url" target="_blank">
            <template>
              <div class="pi">
                <div class="list">
                  <div class="ashi">
                    <div class="thumbnail">
                      <img src="https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616390182322863.jpg" alt=""> 
                    </div>
                    <div>反诈，童你在一起</div>
                  </div>
                  <div class="poster">
                    <van-image height="100%" lazy-load :src="v.cover" />
                  </div>
                  <div class="info">
                    <div class="title">{{ v.title }}</div>
                    <div class="click-to-join">点击这里参与吧>></div>
                    
                  </div>
                </div>
              </div>
            </template>
          </a>
          <router-link
            v-else
           :to="v.url"
        >
          <template>
              <div class="pi">
                <div class="list">
                  <div class="ashi">
                    <div class="thumbnail">
                      <img src="https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616390182322863.jpg" alt=""> 
                    </div>
                    <div>反诈，童你在一起</div>
                  </div>
                  <div class="poster">
                    <van-image height="100%" lazy-load :src="v.cover" />
                  </div>
                  <div class="info">
                    <div class="title">{{ v.title }}</div>
                    <div class="click-to-join">点击这里参与吧>></div>
                    
                  </div>
                </div>
              </div>
            </template>
          </router-link>
        </div>

      </div>
    </div>

    <!-- 登记start -->
    <van-overlay :show="showSignModal" class="sign">
      <van-form @submit="doSign" class="sign-form">
        <div class="title">
          “为保障您在活动中的权益，请您务必填写真实的个人信息，【掌上温岭客户端】将对您的信息进行严格保密，请您放心填写！”
        </div>

        
        <van-field
          required
          v-model="username"
          :placeholder="'请输入姓名'"
        />

        <van-field
          required
          readonly
          clickable
          name="picker"
          :value="village"
          :placeholder="'点击选择学校'"
          @click="showSchoolPicker = true"
        />

        <van-field
          required
          v-model="class_"
          :placeholder="'请输入班级'"
        />

        <van-field
          required
          v-model="phone"
          type="number"
          :placeholder="'请输入手机号码'"
        />

        <van-popup v-model="showSchoolPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="townSchool"
            @confirm="onConfirm"
            @cancel="showSchoolPicker = false"
          />
        </van-popup>

        <div class="sign-btn">
          <van-button
            native-type="submit"
            :disabled="!village || !phone || !username || !class_"
            >
            <img src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782901451174.png" alt="">
            </van-button
          >
        </div>
      </van-form>
    </van-overlay>
    <!-- 登记end -->

    <van-overlay :show="showFirstLoginModal" @click="showFirstLoginModal = false">
      <div class="wrapper">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782895667289.png" class="integral-img" alt="">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { getSchool, addUser, getFanzhaUserInfo, hasLogin, saveFirstLogin } from "@/api/fanzha";
import { Lazyload } from "vant";

Vue.use(Lazyload);

export default {
  name: "Home",
  data() {
    return {
      themeId: 3,
      activityList: [
        {title: '反诈小喇叭', type: 2, url: 'https://fifaclhs.tp.tmuact.com/new_vote?q=YunSLffOd', cover: 'https://i.tmuyun.com/webpic/W0202310/W020231017/W020231017378060861983.jpg'},
        {title: '反诈小先锋', type: 2, url: 'https://hw.wlxww.com/edu/index.php?m=Home&c=index&a=leader', cover: 'https://i.tmuyun.com/webpic/W0202307/W020230719/W020230719355201579460.jpg'},
        {title: '2023反诈系列活动之阿狮警长说反诈', type: 1, url: 'list', cover: 'https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616412811358104.jpg'},
        {title: '手工创意大赛', type: 2, url: 'https://app.tmuyun.com/community/?gaze_control=02&tenantId=3&only=3&id=483', cover: 'https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630467539503951.jpg'}
      ],
      username: "",
      class_: "",
      phone: "",
      schoolId: "",
      showSchoolPicker: false,
      townSchool: [],
      showSignModal: false,
      village: "",
      videoList: [],
      hasLogin: false,
      showFirstLoginModal: false
    };
  },
  mounted(){
    getFanzhaUserInfo({ themeId: this.themeId }).then((res) => {
      if (res.code == 1 && res.data == null) {
        this.showSignModal = true;
      }else{
        hasLogin({theme_id: this.themeId}).then((res) => {
          if(res.code == 1){
            this.hasLogin = res.data;
            if(!this.hasLogin){
              this.loginToday();
            }
          }
        });
      }
    });

    getSchool({theme_id: this.themeId}).then((res) => {
      if (res.code == 1) {
        this.townSchool = res.data;
      }
    });
  }, 
  methods: {
    onConfirm(value, index) {
      this.village = value[1];
      this.schoolId = this.townSchool[index[0]]['children'][index[1]]['id'];
      this.showSchoolPicker = false;
    },
    loginToday(){
      saveFirstLogin({theme_id: this.themeId}).then((res) => {
        if(res.code == 1){
          this.showFirstLoginModal = true;
          this.hasLogin = true;
        }else if(res.code == 0){
          Toast.error(res.msg);
        }
      })
    },
    doSign() {
      // 用户登记
      var params = {
        class: this.class_,
        username: this.username,
        village: this.village,
        school_id: this.schoolId,
        phone: this.phone,
        themeId: this.themeId,
      };
      // console.log(params);
      addUser(params).then((res) => {
        if (res.code == 1) {
          this.showSignModal = false;
          // Toast.success(res.msg);
          // 调用第一次登录加分
          if(!this.hasLogin){
            this.loginToday();
          }
        } else {
          Dialog.alert({
            message: res.msg,
          });
        }
      });
    },
    isExternalLink(v) {
      return typeof v.url === 'string' && v.url.startsWith('http')
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #000;
}

.sign {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .sign-form {
    background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782898004576.png);
    background-size: 100%;
    background-repeat: no-repeat;
    min-height: 400px;
    width: 70vw;
    padding: 60px 40px 10px 40px;
    border-radius: 10px;
    .title {
      color: #000;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
  .sign-btn {
    margin-top: 10px;
    text-align: center;
    button {
      background-color: transparent;
      border: 0px;
      padding: 0;
    }
    img {
      width: 70%;
    }
  }
}

.lists {
  margin-top: 10px;
  .pi {
    
    background-color: #fff;
    border-radius: 0px 0px 15px 15px;
    margin-bottom: 30px;
    .list {
      position: relative;
      border-radius: 10px;
      .ashi {
        display: flex;
        align-items: center;
        height: 50px;
        line-height: 50px;
        font-weight: bold;
        padding-left: 10px;
        .thumbnail{
          width: 40px;
          height: 40px;
          margin-right: 5px;
          img{
            width: 100%;
          }
        }
      }
      .poster {
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .info {
        margin-left: 10px;
        .title {
          margin-top: 5px;
          font-weight: bold;
        }
        .click-to-join {
          margin-top: 5px;
          font-size: 14px;
          color: gray;
          padding-bottom: 10px;
        }
      }
    }
  }
}

.wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .integral-img {
      width: 60%;
    }
  }
</style>
